import React, { Component } from "react";
import Steps from "./Steps/StepIndex";

export default class CompletedSteps extends Component {
  renderSteps = () => {
    return this.props.steps.map(step => {
      const Step = Steps[step];

      return <Step key={step} />;
    });
  };
  render() {
    return <div>{this.renderSteps()}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/CompletedSteps.js